module.exports = __webpack_public_path__ + "img/Outage-Web.e25b0351.svg";